import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthTokenInterceptor } from './interceptors/auth-token.interceptor';
import { TimingInterceptor } from './interceptors/timing.interceptor';
import { ErrorHandlerInterceptor } from './interceptors/error-handler.interceptor';
import { ResponseConverterInterceptor } from './interceptors/response-converter.interceptor';


@NgModule({
	declarations: [],
	imports: [
		CommonModule
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TimingInterceptor,
			multi: true
		},

		{
			provide: HTTP_INTERCEPTORS,
			useClass: ResponseConverterInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorHandlerInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthTokenInterceptor,
			multi: true
		}
	]
})
export class CoreModule {
}
